import { colors, fonts, links } from "../../components/common/mixins";
import styled from "styled-components";
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from "@mui/material";
import React from "react";
import { CheckboxDefault, CheckboxSelected } from "../../components/icons";
import { SmallLink } from "../typography/Links";
import { useReservationResources } from "../../pageComponents/reservationPage/hooks/useReservationResources";
import { getLocaleSegment } from "../../utils/Utils";

interface DsCheckboxProps {
  label: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  required: boolean;
  id?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}

const DSFormHelperText = styled(FormHelperText)`
  && {
    ${fonts.normalTextExtraSmall()};
    margin: 0;
    padding-left: 28px;
  }
  &&.Mui-error {
    color: ${colors.danger};
  }
`;

const DSFormControlLabel = styled(FormControlLabel)`
  gap: 8px;
  && {
    margin-right: 0;
    align-items: flex-start;
  }
  & .MuiCheckbox-root {
    padding: 2px 0 0 0;
    &.Mui-focusVisible svg path {
      stroke: ${colors.primary};
    }
  }
  & .MuiFormControlLabel-label {
    ${fonts.normalTextSmall()}
    color: ${colors.darkText};
    padding: 1px 2px 4px;
    & p {
      margin: 0;
      display: inline;
    }
    & a {
      ${links.linkSmallBrightPurple()}
    }
  }
`;

export const TermsLabel = () => {
  const r = useReservationResources();
  const termsUrl = `/${getLocaleSegment()}/tickets/terms/`;
  return (
    <>
      {r.AcceptTerms1}{" "}
      <SmallLink
        href={termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {r.AcceptTerms2}
      </SmallLink>
    </>
  );
};

export function DsCheckbox({
  label,
  checked,
  onChange,
  required,
  id,
  error,
  helperText,
}: DsCheckboxProps) {
  const hasError = error || !!helperText;
  return (
    <FormControl error={hasError}>
      <DSFormControlLabel
        control={
          <Checkbox
            id={id}
            icon={<CheckboxDefault color={hasError ? colors.danger : undefined} strokeWidth={hasError ? 0.8 : undefined} />}
            checkedIcon={<CheckboxSelected />}
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            required={required}
          />
        }
        label={
          required ? (
            <>
              {label}
              <span style={{ color: colors.danger }}>*</span>
            </>
          ) : (
            label
          )
        }
      />
      {helperText && <DSFormHelperText>{helperText}</DSFormHelperText>}
    </FormControl>
  );
}
